module.exports = __webpack_public_path__ + "img/DSC_0688.NEF.3193fe59.jpg";